<template>
  <div>
    <v-layout :style="{ margin: '-16px' }" wrap>
      <v-flex class="pt-3 px-3" xs12>
        <v-layout>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <v-btn @click="handleSearchButtonClick">
              <v-icon>search</v-icon>
              Search
            </v-btn>
            <v-btn color="primary" @click="handleExportButtonClick">
              <v-icon>logout</v-icon>
              Export
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex class="pa-3" xs12>
        <slot name="status" v-bind="{ filter, statusStatisticData, loading }"></slot>
      </v-flex>
      <v-flex class="pa-3" xs12 md7>
        <slot name="agent" v-bind="{ filter, agentStatistics, loading }"></slot>
      </v-flex>
      <v-flex class="pa-3" xs12 md5>
        <slot name="response" v-bind="{ filter, responseStatistics, loading }"></slot>
      </v-flex>
      <v-flex class="pa-3" xs12>
        <slot name="topQuestion" v-bind="{ filter }"></slot>
      </v-flex>
    </v-layout>

    <StatisticsSearchDialog
      v-model="filter"
      :open.sync="statisticsSearchDialog.isOpen"
      @input="handleStatisticsSearchDialogInput"
    />
  </div>
</template>

<script>
import ttbApi from '@/api/ttb'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import StatisticsSearchDialog from './StatisticsSearchDialog.vue'

import utc from 'dayjs/plugin/utc'
import tz from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

dayjs.extend(utc)
dayjs.extend(tz)
export default {
  name: 'StatisticsVue',
  components: {
    StatisticsSearchDialog
  },
  data() {
    return {
      statisticsSearchDialog: {
        isOpen: false,
        data: {}
      },
      filter: {
        startTime: dayjs().format('YYYY-MM-DD'),
        endTime: dayjs().format('YYYY-MM-DD'),
        role: '',
        channel: '',
        search_page_id: ''
      },
      statusStatisticData: undefined,
      agentStatistics: undefined,
      responseStatistics: undefined,
      loading: true
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  watch: {
    filter: {
      handler() {
        this.handleFetchData()
      },
      deep: true
    }
  },
  mounted() {
    this.handleFetchData()
  },
  methods: {
    async handleFetchData() {
      this.loading = true
      await this.handleGetNumberOfCaseStatus()
      await this.handleGetChatlogCountAgentBot()
      await this.handleGetAverageResponseTime()
      this.loading = false
    },
    async handleGetNumberOfCaseStatus() {
      const response = await ttbApi.getTicketCardCounts({
        params: {
          ...this.filter,
          startTime: this.filter.startTime
            ? dayjs(this.filter.startTime).format('YYYY-MM-DD')
            : undefined,
          endTime: this.filter.endTime
            ? dayjs(this.filter.endTime).format('YYYY-MM-DD')
            : undefined,
          pageid: this.selectedBot.pageid
        }
      })
      if (response.data.responsecode == 200 && response.data.data) {
        const { data } = response.data
        this.statusStatisticData = data
      } else {
        this.statusStatisticData = {
          answered: 0,
          pending: 0,
          closed: 0,
          cancelled: 0,
          cancelled_by_customer: 0,
          cold_case: 0,
          success: 0,
          closed_by_system: 0,
          closed_with_survey: 0,
          closed_without_survey: 0
        }
      }
    },
    async handleGetChatlogCountAgentBot() {
      const response = await ttbApi.postChatlogCountAgentBot({
        data: {
          ...this.filter,
          start_date: this.filter.startTime
            ? dayjs(this.filter.startTime).format('YYYY-MM-DD')
            : undefined,
          end_date: this.filter.endTime
            ? dayjs(this.filter.endTime).format('YYYY-MM-DD')
            : undefined,
          page_id: this.selectedBot.pageid
        }
      })

      if (response.status == 200 && response.data) {
        const { admin, bot, bot_ans, admin_ans, total_ans } = response.data
        if (admin.length > bot.length) {
          for (let i = 0; i < admin.length; i++) {
            if (bot[i]) {
              if (admin[i].date != bot[i].date) {
                bot.splice(i, 0, {
                  date: dayjs.tz(`${admin[i].date}`, 'Asia/Bangkok').valueOf(),
                  count: 0
                })
              } else {
                bot[i].date = dayjs.tz(`${admin[i].date}`, 'Asia/Bangkok').valueOf()
              }
            } else {
              bot.push({
                date: dayjs.tz(`${admin[i].date}`, 'Asia/Bangkok').valueOf(),
                count: 0
              })
            }
          }
        } else if (bot.length > admin.length) {
          for (let i = 0; i < bot.length; i++) {
            if (admin[i]) {
              if (admin[i].date != bot[i].date) {
                admin.splice(i, 0, {
                  date: dayjs.tz(`${bot[i].date}`, 'Asia/Bangkok').valueOf(),
                  count: 0
                })
              } else {
                admin[i].date = dayjs.tz(`${bot[i].date}`, 'Asia/Bangkok').valueOf()
              }
            } else {
              admin.push({
                date: dayjs.tz(`${bot[i].date}`, 'Asia/Bangkok').valueOf(),
                count: 0
              })
            }
          }
        }
        this.agentStatistics = {
          agentData: admin,
          botData: bot,
          bot_ans: bot_ans,
          admin_ans: admin_ans,
          total_ans: total_ans
        }
      } else {
        this.agentStatistics = {
          agentData: [],
          botData: [],
          bot_ans: 0,
          admin_ans: 0,
          total_ans: 0
        }
      }
    },
    handleStatisticsSearchDialogInput(data) {
      this.filter = {
        ...data,
        startTime: data.startTime ? data.startTime : undefined,
        endTime: data.endTime ? data.endTime : undefined,
        role: data.role ? data.role : undefined,
        channel: data.channel ? data.channel : undefined,
        search_page_id: data.search_page_id ? data.search_page_id : undefined
      }
    },
    async handleGetAverageResponseTime() {
      const response = await ttbApi.postAverageResponseTime({
        data: {
          ...this.filter,
          start_date: this.filter.startTime
            ? dayjs(this.filter.startTime).format('YYYY-MM-DD')
            : undefined,
          end_date: this.filter.endTime
            ? dayjs(this.filter.endTime).format('YYYY-MM-DD')
            : undefined,
          page_id: this.selectedBot.pageid
        }
      })
      if (response.data.data) {
        const { data } = response.data
        this.responseStatistics = {
          received: data.recived_ticket || 0,
          resolved: data.resolved_ticket || 0,
          averageFirstResponseTime: data.first_response_avg || 0,
          averageResolvedTicketTime: data.resolved_avg || 0
        }
      } else {
        this.responseStatistics = {
          received: 0,
          resolved: 0,
          averageFirstResponseTime: 0,
          averageResolvedTicketTime: 0
        }
      }
      // console.log(response)
    },
    async handleExportButtonClick() {
      this.$emit('export', {
        filter: this.filter
      })
    },
    handleSearchButtonClick() {
      this.statisticsSearchDialog.isOpen = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/Overview/Statistics.vue